import React from "react";
import { Container, Text, ButtonsContainer, TooltipTitle } from "./cash-card-selector.styled";
import RoundedButton from "@/components/rounded-button";
import { paymentMethods } from "@/constants";
import PaymentAmountContainer from "@/components/payment-amount-container";
import HtmlTooltip from "@/components/htmlTooltip";

export default function CashCardSelector({
    primaryPaymentMethod,
    setSecondaryPaymentMethod,
    selectedSecondaryPaymentMethod,
    amount,
    openPaymentMethodTooltip,
    openCashTooltip,
    cashValue,
    setCashValue,
    change,
}) {
    return (
        <HtmlTooltip
            arrow
            open={openPaymentMethodTooltip}
            placement="bottom-start"
            title={<TooltipTitle>Seleccione el método de pago</TooltipTitle>}
        >
            <Container>
                <Text>Elija un método de pago:</Text>
                <ButtonsContainer>
                    <RoundedButton
                        onClickHandler={() => setSecondaryPaymentMethod(paymentMethods.efectivo)}
                        backgroundcolor={
                            selectedSecondaryPaymentMethod === paymentMethods.efectivo ? "#6ec4e8" : "#c8c8c8"
                        }
                        text="Efectivo"
                    />
                    <RoundedButton
                        onClickHandler={() => setSecondaryPaymentMethod(paymentMethods.tarjeta)}
                        backgroundcolor={
                            selectedSecondaryPaymentMethod === paymentMethods.tarjeta ? "#6ec4e8" : "#c8c8c8"
                        }
                        text="Tarjeta"
                    />
                </ButtonsContainer>
                {selectedSecondaryPaymentMethod && (
                    <PaymentAmountContainer
                        amount={amount}
                        primaryPaymentMethod={primaryPaymentMethod}
                        secondaryPaymentMethod={selectedSecondaryPaymentMethod}
                        setCashValue={setCashValue}
                        opentooltip={openCashTooltip}
                        cashValue={cashValue}
                        change={change}
                    />
                )}
            </Container>
        </HtmlTooltip>
    );
}
